import {isMobile} from '../../../../../../commons/selectors/environment'
import {isNarrow} from '../../../selectors/list-settings'
import {AppProps} from '../../app/interfaces'
import {connect} from '../../runtime-context/connect'
import {ListStateProps} from './interfaces'
import {List as ListLayoutPresentation} from './list'

const mapRuntime = ({state, host: {dimensions}}: AppProps): ListStateProps => ({
  narrow: isNarrow(state, dimensions),
  mobile: isMobile(state),
})

export default connect<{}, ListStateProps>(mapRuntime)(ListLayoutPresentation)
